document.addEventListener('DOMContentLoaded', function () {
	const taWidget = document.querySelector('.ta-widget-frontpage')

	// Once the TripAdvisor Widget is fully loaded
	// The script doesn't need a prior div height anymore
	setTimeout(() => {
		if (taWidget) {
			taWidget.classList.remove('hidden')
			taWidget.style.height = '0px'
		}
	}, 1000)
})



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/ta-widget.js